import { defineProfile } from "./define.js";

export const TRAVEL_PROFILE = defineProfile("travel", {
  labels: ["contacts", "bookings", "services"],
  home: [
    "trips_this_month",
    "deposits_waiting",
    "documents_missing",
    "unread_chats",
    "ai_handoffs",
  ],
  kpis: [
    "trip_fill_rate",
    "trips_this_month",
    "deposits_collected",
    "bookings",
    "conversations",
    "ai_handoffs",
  ],
  panel: ["trips", "travelers_documents", "payments_balance", "quotes"],
  quickActions: ["book_trip", "record_deposit", "private_trip_quote"],
  contactFields: [
    { key: "passport_expiry", kind: "date", label: { ar: "انتهاء الجواز", en: "Passport expiry" } },
    { key: "nationality", kind: "text", label: { ar: "الجنسية", en: "Nationality" } },
  ],
  aiTools: ["search_kb", "lookup_availability", "hold_seats", "save_lead", "escalate"],
  cloudStarterMenu: "travel_menu",
});
